import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getProfile } from "../../redux/GetProfileSlice";
import Loader from "../Loader/Loader";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const location = useLocation();

  const profileResponse = useSelector((state) => state.getProfileReducer.data);
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (token) {
      dispatch(getProfile());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (profileResponse != null) {
      setProfileLoaded(true);
    }
  }, [profileResponse]);

  const isSubscribed = profileResponse?.data?.isSubscribed === 1;
  const currentPath = location.pathname;
  const subscriptionAllowedPaths = ["/subscription-plans", "/subscription/success"];
  useEffect(() => {
    if (profileLoaded && profileResponse && profileResponse?.status === 1 && !isSubscribed && !subscriptionAllowedPaths.includes(currentPath) && profileResponse.data.role === 'User') {
      const timer = setTimeout(() => {
        setShouldRedirect(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [profileLoaded, isSubscribed, currentPath]);

  if (!token) {
    return <Navigate to="/SignIn" />;
  }

  if (!profileLoaded) {
    return <Loader />;
  }

  if (profileResponse?.data?.role === 'User' && !isSubscribed && !subscriptionAllowedPaths.includes(currentPath)) {
    if (shouldRedirect) {
      return <Navigate to="/subscription-plans" />;
    } else {
      return <Loader message='Verifying your subscription... Redirecting to plans' />
    }
  }

  return children;
};

export default PrivateRoute;